import { LISTING_STATUSES } from "repoV2/features/Listing/Listing.constants";
import { EXPRESS_INTEREST_SUBMIT_BTN_TEXTS } from "../constants/ExpressInterest.constants";

/**
 * Based upon the status of the listing, this returns the Text of the CTA
 * @param { number } status Status of the listing
 * @param { boolean } hideLstingPrice Check whether the 'hide_price' check of event metadata is true
 * @returns text of the button of express interest/ Waitlist form
 */
export const getExpressInterestButtonText = ({
    listingStatus,
    hideListingPrice,
    isMerchandiseSoldout,
}: {
    listingStatus: number;
    hideListingPrice: boolean;
    isMerchandiseSoldout?: boolean;
}) => {
    if (listingStatus === LISTING_STATUSES.SOLD_OUT || isMerchandiseSoldout) {
        return EXPRESS_INTEREST_SUBMIT_BTN_TEXTS.JOIN_WAITLIST;
    } else if (listingStatus === LISTING_STATUSES.EXPIRED || hideListingPrice) {
        return EXPRESS_INTEREST_SUBMIT_BTN_TEXTS.EXPRESS_INTEREST;
    } else {
        return EXPRESS_INTEREST_SUBMIT_BTN_TEXTS.EXPRESS_INTEREST;
    }
};
